import { render, staticRenderFns } from "./UserBar.vue?vue&type=template&id=57d536e0&scoped=true&"
import script from "./UserBar.vue?vue&type=script&lang=js&"
export * from "./UserBar.vue?vue&type=script&lang=js&"
import style0 from "./UserBar.vue?vue&type=style&index=0&id=57d536e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d536e0",
  null
  
)

export default component.exports